"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bech32 = __importStar(require("bech32"));
class Bech32 {
    static encode(prefix, data) {
        const address = bech32.encode(prefix, bech32.toWords(data));
        return address;
    }
    static decode(address) {
        const decodedAddress = bech32.decode(address);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array(bech32.fromWords(decodedAddress.words)),
        };
    }
}
exports.Bech32 = Bech32;
//# sourceMappingURL=bech32.js.map